import React from "react";
import ServiceCard from "./Service-Card/ServiceCard";
import SectionHeader from "../Common/Section-Header/SectionHeader";
import Fade from "react-reveal/Fade";
import "./Service.scss";
import "scss/_main.scss";
import ServicesData from "data/services.json";

const Service = () => {
  const servicesDataWithId = ServicesData.map((data, index) => ({
    id: index + 1,
    ...data,
  }));

  return (
    <section className="section-separator" id="service">
      <div className="container mb-5">
        <Fade bottom>
          <SectionHeader subtitle="Services" title="What I do" align="center" />
        </Fade>
        <div className="row">
          {servicesDataWithId.map((service) => (
            <ServiceCard
              key={service.id}
              title={service.title}
              description={service.description}
              icon={service.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Service;
